// src/ui/client/btn/lang/LocaleSwitcherNav.tsx
'use client';
import { useLocale } from 'next-intl';
import type { ChangeEventHandler } from 'react';

import { usePathname, useRouter } from '@/libs/i18n/hook';
import { allowedLocales, localeFlags } from '@/libs/i18n/locales';

import styles from './LocaleSwitcherNav.module.css';

export default function LocaleSwitcherNav() {
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocale();

  const handleChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
    const selectedLocale = event.target.value;
    router.push(pathname, { locale: selectedLocale });
    router.refresh();
  };

  return (
    <div className={styles.localeSwitcher}>
      <select id='locale-switcher' aria-label='Change language' defaultValue={locale} onChange={handleChange} className={styles.select} aria-live='polite'>
        {allowedLocales.map((locale) => (
          <option className={styles.flag} key={locale} value={locale}>
            {localeFlags[locale]}
          </option>
        ))}
      </select>
    </div>
  );
}
